export const PORT_DICTIONARY = [
  { code:'ALY', name:'Alexandria', country:'EG', region:'Mediterranean', terminal:'Alexandria Port', utc:2 },
  { code:'AMS', name:'Amsterdam', country:'NL', region:'North Europe', terminal:'Amsterdam Port', utc:1 },
  { code:'ANT', name:'Antwerp', country:'BE', region:'North Europe', terminal:'Port of Antwerp-Bruges', utc:1 },
  { code:'ASH', name:'Ashdod', country:'IL', region:'Mediterranean', terminal:'Ashdod Port', utc:2 },
  { code:'BAL', name:'Baltimore', country:'US', region:'US East Coast', terminal:'Baltimore Auto Terminals', utc:-5 },
  { code:'BAL-MAT', name:'Baltimore - Mid-Atlantic', country:'US', region:'US East Coast', terminal:'Mid-Atlantic Terminal', utc:-5 },
  { code:'BAL-TPA', name:'Baltimore - Tradepoint', country:'US', region:'US East Coast', terminal:'Tradepoint Atlantic', utc:-5 },
  { code:'BAL-DUN', name:'Baltimore - Dundalk', country:'US', region:'US East Coast', terminal:'Dundalk Marine Terminal', utc:-5 },
  { code:'BCN', name:'Barcelona', country:'ES', region:'Mediterranean', terminal:'Port de Barcelona', utc:1 },
  { code:'BAU', name:'Bauan', country:'PH', region:'Philippines', terminal:'Bauan Port', utc:8 },
  { code:'BKI', name:'Kota Kinabalu', country:'MY', region:'Malaysia', terminal:'Kota Kinabalu Port', utc:8 },
  { code:'BRE', name:'Bremerhaven', country:'DE', region:'North Europe', terminal:'BLG AutoTerminal', utc:1 },
  { code:'BRI', name:'Brisbane', country:'AU', region:'Australia', terminal:'Port of Brisbane', utc:10 },
  { code:'BRS', name:'Bristol', country:'UK', region:'UK', terminal:'Royal Portbury Dock', utc:0 },
  { code:'BRU', name:'Bruges', country:'BE', region:'North Europe', terminal:'Zeebrugge Outer Port', utc:1 },
  { code:'BUS', name:'Busan', country:'KR', region:'Korea', terminal:'Busan Port', utc:9 },
  { code:'CAS', name:'Casablanca', country:'MA', region:'North Africa', terminal:'Port of Casablanca', utc:1 },
  { code:'CHB', name:'Chiba', country:'JP', region:'Japan', terminal:'Chiba Port', utc:9 },
  { code:'CHS', name:'Charleston', country:'US', region:'US East Coast', terminal:'Columbus Street Terminal', utc:-5 },
  { code:'CIV', name:'Civitavecchia', country:'IT', region:'Mediterranean', terminal:'Port of Civitavecchia', utc:1 },
  { code:'DUB', name:'Dublin', country:'IE', region:'UK / Ireland', terminal:'Dublin Port', utc:0 },
  { code:'DBN', name:'Durban', country:'ZA', region:'South Africa', terminal:'Point RoRo', utc:2 },
  { code:'DRC', name:'Derince', country:'TR', region:'Mediterranean', terminal:'Derince Port', utc:3 },
  { code:'EMD', name:'Emden', country:'DE', region:'North Europe', terminal:'Emder Hafen RoRo', utc:1 },
  { code:'FOS', name:'Fos-sur-Mer', country:'FR', region:'Mediterranean', terminal:'Fos Port', utc:1 },
  { code:'FRE', name:'Fremantle', country:'AU', region:'Australia', terminal:'Fremantle Ports', utc:8 },
  { code:'GAL', name:'Galveston', country:'US', region:'US Gulf', terminal:'Port of Galveston', utc:-6 },
  { code:'GEB', name:'Gebze', country:'TR', region:'Mediterranean', terminal:'Gebze Port', utc:3 },
  { code:'GIT', name:'Gioia Tauro', country:'IT', region:'Mediterranean', terminal:'Gioia Tauro Port', utc:1 },
  { code:'GNE', name:'Ghent', country:'BE', region:'North Europe', terminal:'North Sea Port Ghent', utc:1 },
  { code:'GOT', name:'Gothenburg', country:'SE', region:'Nordics', terminal:'Arendal RoRo', utc:1 },
  { code:'HAM', name:'Hamburg', country:'DE', region:'North Europe', terminal:'O Swaldkai Terminal', utc:1 },
  { code:'HEL', name:'Helsinki', country:'FI', region:'Nordics', terminal:'Vuosaari Harbour', utc:2 },
  { code:'HIR', name:'Hiroshima', country:'JP', region:'Japan', terminal:'Hiroshima Port', utc:9 },
  { code:'HCM', name:'Ho Chi Minh', country:'VN', region:'Vietnam', terminal:'Ho Chi Minh Port', utc:7 },
  { code:'HPH', name:'Hai Phong', country:'VN', region:'Vietnam', terminal:'Hai Phong Port', utc:7 },
  { code:'HOU', name:'Houston', country:'US', region:'US Gulf', terminal:'Bayport Vehicle Terminal', utc:-6 },
  { code:'INC', name:'Incheon', country:'KR', region:'Korea', terminal:'Incheon Port', utc:9 },
  { code:'IST', name:'Istanbul', country:'TR', region:'Mediterranean', terminal:'Ambarli Port', utc:3 },
  { code:'JAX', name:'Jacksonville', country:'US', region:'US East Coast', terminal:'Blount Island Marine', utc:-5 },
  { code:'JEB', name:'Jebel Ali', country:'AE', region:'Gulf', terminal:'DP World RoRo', utc:4 },
  { code:'JKT', name:'Jakarta', country:'ID', region:'Indonesia', terminal:'Port of Jakarta', utc:7 },
  { code:'KCH', name:'Kuching', country:'MY', region:'Malaysia', terminal:'Kuching Port', utc:8 },
  { code:'KOB', name:'Kobe', country:'JP', region:'Japan', terminal:'Port of Kobe', utc:9 },
  { code:'KOP', name:'Koper', country:'SI', region:'Mediterranean', terminal:'Port of Koper', utc:1 },
  { code:'LAG', name:'Lagos', country:'NG', region:'West Africa', terminal:'Lagos Port Complex', utc:1 },
  { code:'LCB', name:'Laem Chabang', country:'TH', region:'Thailand', terminal:'Laem Chabang Port', utc:7 },
  { code:'LIV', name:'Livorno', country:'IT', region:'Mediterranean', terminal:'Port of Livorno', utc:1 },
  { code:'LON', name:'London Gateway', country:'UK', region:'UK', terminal:'London Gateway Port', utc:0 },
  { code:'LGB', name:'Long Beach', country:'US', region:'US West Coast', terminal:'Port of Long Beach', utc:-8 },
  { code:'LAX', name:'Los Angeles', country:'US', region:'US West Coast', terminal:'Port of Los Angeles', utc:-8 },
  { code:'MAL', name:'Malmo', country:'SE', region:'Nordics', terminal:'Copenhagen Malmo Port', utc:1 },
  { code:'MAN', name:'Manzanillo', country:'MX', region:'Mexico', terminal:'Port of Manzanillo', utc:-6 },
  { code:'MEL', name:'Melbourne', country:'AU', region:'Australia', terminal:'Port of Melbourne', utc:10 },
  { code:'MIA', name:'Miami', country:'US', region:'US East Coast', terminal:'PortMiami', utc:-5 },
  { code:'MOB', name:'Mobile', country:'US', region:'US Gulf', terminal:'Port of Mobile', utc:-6 },
  { code:'NAG', name:'Nagoya', country:'JP', region:'Japan', terminal:'Tobishima RoRo', utc:9 },
  { code:'NAP', name:'Naples', country:'IT', region:'Mediterranean', terminal:'Port of Naples', utc:1 },
  { code:'NEW', name:'Port Newark', country:'US', region:'US East Coast', terminal:'Port Newark Car Terminal', utc:-5 },
  { code:'NYC', name:'New York', country:'US', region:'US East Coast', terminal:'Port of New York', utc:-5 },
  { code:'OAK', name:'Oakland', country:'US', region:'US West Coast', terminal:'Port of Oakland', utc:-8 },
  { code:'PAN', name:'Panama', country:'PA', region:'Central America', terminal:'Port of Panama', utc:-5 },
  { code:'PIR', name:'Piraeus', country:'GR', region:'Mediterranean', terminal:'Port of Piraeus', utc:2 },
  { code:'PKG', name:'Port Klang', country:'MY', region:'Southeast Asia', terminal:'Port Klang', utc:8 },
  { code:'PTK', name:'Port Kelang', country:'MY', region:'Southeast Asia', terminal:'Port Klang', utc:8 },
  { code:'RTM', name:'Rotterdam', country:'NL', region:'North Europe', terminal:'Port of Rotterdam', utc:1 },
  { code:'SAL', name:'Salerno', country:'IT', region:'Mediterranean', terminal:'Port of Salerno', utc:1 },
  { code:'SAG', name:'Sagunto', country:'ES', region:'Mediterranean', terminal:'Port of Sagunto', utc:1 },
  { code:'ALT', name:'Altamira', country:'MX', region:'Mexico Gulf', terminal:'Port of Altamira', utc:-6 },
  { code:'DAV', name:'Davisville', country:'US', region:'US East Coast', terminal:'Port of Davisville', utc:-5 },
  { code:'VER', name:'Veracruz', country:'MX', region:'Mexico Gulf', terminal:'Port of Veracruz', utc:-6 },
  { code:'SAN', name:'San Diego', country:'US', region:'US West Coast', terminal:'National City Marine Terminal', utc:-8 },
  { code:'SAV', name:'Savannah', country:'US', region:'US East Coast', terminal:'Colonel Island / Savannah', utc:-5 },
  { code:'SDR', name:'Santander', country:'ES', region:'North Europe', terminal:'Port of Santander', utc:1 },
  { code:'SEA', name:'Seattle', country:'US', region:'US West Coast', terminal:'Port of Seattle', utc:-8 },
  { code:'SHG', name:'Shanghai', country:'CN', region:'China', terminal:'Shanghai Port', utc:8 },
  { code:'SHS', name:'Sheerness', country:'UK', region:'UK', terminal:'Sheerness Port', utc:0 },
  { code:'SIN', name:'Singapore', country:'SG', region:'Singapore', terminal:'Pasir Panjang RoRo', utc:8 },
  { code:'SOT', name:'Southampton', country:'UK', region:'UK', terminal:'WWTE', utc:0 },
  { code:'SYD', name:'Sydney', country:'AU', region:'Australia', terminal:'Port Botany', utc:10 },
  { code:'TAC', name:'Tacoma', country:'US', region:'US West Coast', terminal:'Port of Tacoma', utc:-8 },
  { code:'TEE', name:'Teesport', country:'UK', region:'UK', terminal:'Teesport', utc:0 },
  { code:'TIL', name:'Tilbury', country:'UK', region:'UK', terminal:'Tilbury RoRo', utc:0 },
  { code:'TCH', name:'Taichung', country:'TW', region:'Taiwan', terminal:'Port of Taichung', utc:8 },
  { code:'TPE', name:'Taipei', country:'TW', region:'Taiwan', terminal:'Port of Taipei', utc:8 },
  { code:'TYH', name:'Toyohashi', country:'JP', region:'Japan', terminal:'Toyohashi Port', utc:9 },
  { code:'VAN', name:'Vancouver', country:'CA', region:'Canada West Coast', terminal:'Port of Vancouver', utc:-8 },
  { code:'VIG', name:'Vigo', country:'ES', region:'North Europe', terminal:'Port of Vigo', utc:1 },
  { code:'YOK', name:'Yokohama', country:'JP', region:'Japan', terminal:'Honmoku RoRo', utc:9 },
  { code:'ZEE', name:'Zeebrugge', country:'BE', region:'North Europe', terminal:'ICO Terminal', utc:1 },
];

const COUNTRY_UTC = {
  AE:4, AU:10, BE:1, CA:-5, CN:8, DE:1, EG:2, ES:1, FI:2, FR:1, GR:2, IE:0,
  ID:7, IL:2, IT:1, JP:9, KR:9, MA:1, MX:-6, MY:8, NG:1, NL:1, PA:-5, PH:8, SE:1, SG:8,
  SI:1, TH:7, TR:3, TW:8, UK:0, US:-5, VN:7, ZA:2,
};

const COUNTRY_TIME_ZONES = {
  AE:'Asia/Dubai', AU:'Australia/Sydney', BE:'Europe/Brussels', CA:'America/Toronto',
  CN:'Asia/Shanghai', DE:'Europe/Berlin', EG:'Africa/Cairo', ES:'Europe/Madrid',
  FI:'Europe/Helsinki', FR:'Europe/Paris', GR:'Europe/Athens', IE:'Europe/Dublin',
  ID:'Asia/Jakarta', IL:'Asia/Jerusalem', IT:'Europe/Rome', JP:'Asia/Tokyo', KR:'Asia/Seoul',
  MA:'Africa/Casablanca', MX:'America/Mexico_City', MY:'Asia/Kuala_Lumpur',
  NG:'Africa/Lagos', NL:'Europe/Amsterdam', PA:'America/Panama', PH:'Asia/Manila', SE:'Europe/Stockholm',
  SG:'Asia/Singapore', SI:'Europe/Ljubljana', TH:'Asia/Bangkok', TR:'Europe/Istanbul', TW:'Asia/Taipei',
  UK:'Europe/London', US:'America/New_York', VN:'Asia/Ho_Chi_Minh', ZA:'Africa/Johannesburg',
};

const PORT_TIME_ZONES = {
  ALY:'Africa/Cairo', AMS:'Europe/Amsterdam', ANT:'Europe/Brussels', ASH:'Asia/Jerusalem',
  BAL:'America/New_York', 'BAL-MAT':'America/New_York', 'BAL-TPA':'America/New_York', 'BAL-DUN':'America/New_York',
  BAU:'Asia/Manila', BCN:'Europe/Madrid', BKI:'Asia/Kuala_Lumpur', BRE:'Europe/Berlin', BRI:'Australia/Brisbane', BRS:'Europe/London',
  BRU:'Europe/Brussels', BUS:'Asia/Seoul', CAS:'Africa/Casablanca', CHB:'Asia/Tokyo',
  CHS:'America/New_York', CIV:'Europe/Rome', DUB:'Europe/Dublin', DBN:'Africa/Johannesburg',
  DRC:'Europe/Istanbul', EMD:'Europe/Berlin', FOS:'Europe/Paris', FRE:'Australia/Perth',
  GEB:'Europe/Istanbul', GIT:'Europe/Rome', GNE:'Europe/Brussels', GOT:'Europe/Stockholm',
  HAM:'Europe/Berlin', HCM:'Asia/Ho_Chi_Minh', HEL:'Europe/Helsinki', HIR:'Asia/Tokyo', HOU:'America/Chicago',
  HPH:'Asia/Ho_Chi_Minh', INC:'Asia/Seoul', IST:'Europe/Istanbul', JAX:'America/New_York', JEB:'Asia/Dubai',
  JKT:'Asia/Jakarta', KCH:'Asia/Kuala_Lumpur', KOB:'Asia/Tokyo', KOP:'Europe/Ljubljana', LAG:'Africa/Lagos', LCB:'Asia/Bangkok', LIV:'Europe/Rome', LON:'Europe/London',
  LGB:'America/Los_Angeles', LAX:'America/Los_Angeles', MAL:'Europe/Stockholm',
  MAN:'America/Mexico_City', MEL:'Australia/Melbourne', MIA:'America/New_York',
  MOB:'America/Chicago', NAG:'Asia/Tokyo', NAP:'Europe/Rome', NEW:'America/New_York',
  NYC:'America/New_York', OAK:'America/Los_Angeles', PAN:'America/Panama',
  PIR:'Europe/Athens', PKG:'Asia/Kuala_Lumpur', PTK:'Asia/Kuala_Lumpur',
  RTM:'Europe/Amsterdam', SAL:'Europe/Rome', SAG:'Europe/Madrid', SAN:'America/Los_Angeles',
  SAV:'America/New_York', SDR:'Europe/Madrid', SEA:'America/Los_Angeles',
  SHG:'Asia/Shanghai', SHS:'Europe/London', SIN:'Asia/Singapore', SOT:'Europe/London',
  SYD:'Australia/Sydney', TAC:'America/Los_Angeles', TEE:'Europe/London',
  TCH:'Asia/Taipei', TIL:'Europe/London', TPE:'Asia/Taipei', TYH:'Asia/Tokyo', VAN:'America/Vancouver',
  VIG:'Europe/Madrid', YOK:'Asia/Tokyo', ZEE:'Europe/Brussels',
};

function inferTimeZone(code, country, utc) {
  if (PORT_TIME_ZONES[code]) return PORT_TIME_ZONES[code];
  const offset = Number(utc);
  if (country === 'US') {
    if (offset <= -8) return 'America/Los_Angeles';
    if (offset === -7) return 'America/Denver';
    if (offset === -6) return 'America/Chicago';
    return 'America/New_York';
  }
  if (country === 'CA') {
    if (offset <= -8) return 'America/Vancouver';
    if (offset === -6) return 'America/Winnipeg';
    return 'America/Toronto';
  }
  if (country === 'AU') {
    if (offset <= 8) return 'Australia/Perth';
    if (offset === 9.5) return 'Australia/Adelaide';
    if (offset === 10) return 'Australia/Sydney';
  }
  if (country === 'MX') {
    if (offset <= -8) return 'America/Tijuana';
    if (offset === -7) return 'America/Hermosillo';
    return 'America/Mexico_City';
  }
  return COUNTRY_TIME_ZONES[country] || '';
}

export function notifyPortsUpdated() {
  window.dispatchEvent(new Event('portsDictionaryUpdated'));
}

export function mergePorts(localPorts, remotePorts) {
  const byCode = new Map();
  (localPorts || []).concat(remotePorts || []).forEach((port) => {
    const normalized = normalizePort(port);
    if (normalized.code && normalized.name) byCode.set(normalized.code, normalized);
  });
  return Array.from(byCode.values()).sort((a, b) => a.name.localeCompare(b.name));
}

export function allPorts(remotePorts) {
  return mergePorts(PORT_DICTIONARY, remotePorts || []);
}

export function uniquePortCode(baseCode, ports) {
  const cleanBase = (baseCode || 'PRT').replace(/[^a-z0-9]/gi, '').slice(0, 6).toUpperCase() || 'PRT';
  const existing = new Set((ports || []).map((port) => port.code));
  if (!existing.has(cleanBase)) return cleanBase;
  for (let i = 2; i < 100; i += 1) {
    const suffix = String(i);
    const code = `${cleanBase.slice(0, Math.max(1, 6 - suffix.length))}${suffix}`;
    if (!existing.has(code)) return code;
  }
  return `${cleanBase.slice(0, 3)}${Date.now().toString().slice(-3)}`;
}

export async function lookupPortOnline(query, existingPorts) {
  const name = String(query || '').trim();
  if (!name) throw new Error('Enter a port name first.');

  const url = 'https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&extratags=1&limit=5&q='
    + encodeURIComponent(`port ${name}`);
  const response = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(`Online lookup failed (${response.status}).`);

  const results = await response.json();
  const place = (Array.isArray(results) ? results : []).find((item) => {
    const type = String(item.type || '').toLowerCase();
    const klass = String(item.class || '').toLowerCase();
    const display = String(item.display_name || '').toLowerCase();
    return type.includes('port') || klass.includes('harbour') || display.includes('port');
  }) || (Array.isArray(results) ? results[0] : null);

  if (!place) throw new Error('No online port match found.');

  const address = place.address || {};
  const country = String(address.country_code || '').toUpperCase() || '--';
  const displayParts = String(place.display_name || name).split(',').map((part) => part.trim()).filter(Boolean);
  const foundName = displayParts[0] || name;
  const generatedCode = foundName.replace(/^(port|harbour|terminal)\s+of\s+/i, '').replace(/[^a-z0-9]/gi, '').slice(0, 3).toUpperCase().padEnd(3, 'X');
  const lon = Number(place.lon);
  const roughUtc = Number.isFinite(lon) ? Math.max(-12, Math.min(14, Math.round(lon / 15))) : 0;

  return normalizePort({
    code: uniquePortCode(generatedCode, existingPorts || PORT_DICTIONARY),
    name: foundName,
    country,
    region: address.state || address.county || address.country || 'Online lookup',
    terminal: displayParts.slice(0, 3).join(', ') || foundName,
    utc: COUNTRY_UTC[country] ?? roughUtc,
    timeZone: inferTimeZone('', country, COUNTRY_UTC[country] ?? roughUtc),
    lat: Number(place.lat),
    lon,
    custom: true,
    source: 'OpenStreetMap Nominatim',
  });
}

export function normalizePort(port) {
  const code = String(port?.code || '').toUpperCase();
  const country = String(port?.country || '--').toUpperCase();
  const utc = Number.isFinite(Number(port?.utc)) ? Number(port.utc) : 0;
  return {
    code,
    name: String(port?.name || ''),
    country,
    region: port?.region || '',
    terminal: port?.terminal || port?.name || '',
    utc,
    timeZone: port?.timeZone || inferTimeZone(code, country, utc),
    custom: port?.custom === true,
    lat: Number.isFinite(Number(port?.lat)) ? Number(port.lat) : undefined,
    lon: Number.isFinite(Number(port?.lon)) ? Number(port.lon) : undefined,
    source: port?.source,
  };
}
